export type TypeVariant =
  | 'attention'
  | 'blocker'
  | 'done'
  | 'routines'
  | 'note'
  | 'campaign'
  | 'urgent'
  | 'pending'
  | 'solved';

export const typeColors: Record<TypeVariant, string> = {
  attention: '#E24D2A',  // Red
  urgent: '#E24D2A',     // Red (alias)
  blocker: '#F9C431',    // Yellow
  pending: '#F9C431',    // Yellow (alias)
  done: '#36B37E',       // Green
  solved: '#36B37E',     // Green (alias)
  routines: '#4A90E2',   // Blue
  note: '#7E4CC9',       // Purple
  campaign: '#D649A6',   // Pink
};

export const typeLabels: Record<TypeVariant, string> = {
  attention: 'Attention',
  urgent: 'Urgent',
  blocker: 'Blocker',
  pending: 'Pending',
  done: 'Done',
  solved: 'Solved',
  routines: 'Routines',
  note: 'Note',
  campaign: 'Campaign',
};
